<template>
  <v-card color="blue lighten-2" dark>
    <v-card-title class="headline blue lighten-3">Search template</v-card-title>

    <v-card-text>
      <v-autocomplete
        v-model="model"
        :items="entries"
        :loading="isLoading"
        :search-input.sync="search"
        color="white"
        hide-no-data
        hide-selected
        item-text="name"
        item-value="API"
        label="av templates"
        placeholder="Start typing to Search"
        prepend-icon="mdi-database-search"
        return-object
      ></v-autocomplete>
    </v-card-text>
    <v-divider></v-divider>
    <v-expand-transition>
      <v-form v-if="model" class="blue lighten-1" ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="model.name" label="Name" required></v-text-field>

        <v-text-field v-model="model.playbook" label="Playbook" readonly></v-text-field>

        <v-text-field v-model="model.description" label="Description" required></v-text-field>

        <v-textarea
          name="input-7-1"
          filled
          label="Label"
          auto-grow
          v-model="model.extra_vars"
          value
        ></v-textarea>

        <v-btn class="mr-4" @click="postData">submit</v-btn>

        <v-btn :disabled="!model" color="grey darken-3" @click="clear">
          Clear
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-form>
    </v-expand-transition>
    <v-card-actions></v-card-actions>
  </v-card>
</template>


<script>
export default {
  data: () => ({
    valid: true,
    checkbox: false,
    isLoading: false,
    model: null,
    search: null,
    entries: []
  }),
  computed: {
    fields() {
      if (!this.model) return [];
      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || "n/a"
        };
      });
    }
  },
  created() {
    this.initialize();
  },
  mounted() {},
  methods: {
    initialize() {
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }

      this.$http
        .get(this.$root.apiUrl + "/api/v1/directory/awx/get_all")
        .then(res => {
          const { count, entries } = res.data;
          this.count = count;
          this.entries = entries;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    submit() {
      this.$v.$touch();
    },
    postData: function() {
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }
      this.$http
        .post("https://si.stratis.pro/api/v1/awx/add", this.model)
        .then(r => {
          // console.log("r: ", JSON.stringify(r, null, 2));
          this.$router.push({ name: "awx" });
        });
    },
    clear() {
      (this.model = null), this.initialize();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/awx/add.vue